import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import Translate from '../Translate';
import Button from '../Button';

import('./style.scss');

function AssignmentRequestHandlers({
  item = {
    ResourceRequestIdentifier: '',
    WorkAssignmentIdentifier: '',
    NotificationIdentifier: '',
    DatetimeOrderFrom: '',
    IsTranslation: false,
  },
  className = '',
  onAccept = () => {},
  onReject = () => {},
  onShowInCalendar = () => {},
  isSelected = false,
}) {
  const navigate = useNavigate();
  return (
    <div className={`tv-assignment-request-handler__container ${className}`}>
      {item.IsTranslation === false && (
        <div
          className={`tv-assignment-request-handler__text my-auto ${
            isSelected ? 'line-selected' : ''
          }`}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            onShowInCalendar(item.NotificationIdentifier);
            navigate('/', {
              state: { dateFocused: item.DatetimeOrderFrom, assigment: item },
            });
          }}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              e.stopPropagation();
              onShowInCalendar(item.NotificationIdentifier);
              navigate('/', {
                state: {
                  dateFocused: item.DatetimeOrderFrom,
                  assigment: item,
                },
              });
            }
          }}
          tabIndex={0}
          role="button"
          aria-label={Translate({ content: 'assignment.showInCalendar' })}
        >
          {Translate({ content: 'assignment.showInCalendar' })}
        </div>
      )}
      <Button
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          onReject(
            false,
            item.ResourceRequestIdentifier,
            item.WorkAssignmentIdentifier,
            item.NotificationIdentifier,
          );
        }}
        className="tv-assignment-request-handler__btn tv-assignment-request-handler__btn-reject"
        label={<i className="material-icons">close</i>}
      />
      <Button
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          onAccept(
            true,
            item.ResourceRequestIdentifier,
            item.WorkAssignmentIdentifier,
            item.NotificationIdentifier,
          );
        }}
        className="tv-assignment-request-handler__btn tv-assignment-request-handler__btn-accept"
        label={<i className="material-icons">check</i>}
      />
    </div>
  );
}

AssignmentRequestHandlers.propTypes = {
  className: PropTypes.string,
  onAccept: PropTypes.func,
  onReject: PropTypes.func,
  onShowInCalendar: PropTypes.func,
  item: PropTypes.shape({
    ResourceRequestIdentifier: PropTypes.string,
    WorkAssignmentIdentifier: PropTypes.string,
    NotificationIdentifier: PropTypes.string,
    DatetimeOrderFrom: PropTypes.string,
    IsTranslation: PropTypes.bool,
  }),
  isSelected: PropTypes.bool,
};

export default AssignmentRequestHandlers;
